import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
} from "recharts";
import { Plus, X, Download, HelpCircle } from "lucide-react";

// Matches the exact chart movement seen in high-end crypto dashboards
const chartData = [
  { date: "2019", tvl: 0.2 },
  { date: "2020", tvl: 12.5 },
  { date: "2021", tvl: 178.0 },
  { date: "2022", tvl: 42.0 },
  { date: "2023", tvl: 58.0 },
  { date: "2024", tvl: 108.0 },
  { date: "2025", tvl: 120.6 },
];

const protocolData = [
  {
    id: 1,
    name: "ether.fi",
    chains: "1 chain",
    category: "Restaking",
    tvl: "$8.462b",
    change1d: "+3.79%",
    values: [72, 89, 58, 59, 48, 72],
  },
  {
    id: 2,
    name: "Spark",
    chains: "2 chains",
    category: "Lending",
    tvl: "$7.344b",
    change1d: "+1.34%",
    values: [20, 10, 19, 19, 29, 1],
  },
  {
    id: 3,
    name: "Ethena",
    chains: "1 chain",
    category: "Stablecoins",
    tvl: "$6.49b",
    change1d: "+0.01%",
    values: [100, 10, 10, 12, 10, 33],
  },
  {
    id: 4,
    name: "Sky",
    chains: "1 chain",
    category: "Lending",
    tvl: "$6.147b",
    change1d: "-0.26%",
    values: [90, 28, 12, 11, 94, 47],
  },
  {
    id: 5,
    name: "Lido",
    chains: "1 chain",
    category: "Liquid Staking",
    tvl: "$28.12b",
    change1d: "+0.45%",
    values: [85, 82, 88, 84, 86, 85],
  },
  {
    id: 6,
    name: "EigenLayer",
    chains: "1 chain",
    category: "Restaking",
    tvl: "$11.23b",
    change1d: "+2.10%",
    values: [40, 55, 62, 78, 92, 110],
  },
  {
    id: 7,
    name: "Aave V3",
    chains: "12 chains",
    category: "Lending",
    tvl: "$10.55b",
    change1d: "+1.12%",
    values: [60, 62, 58, 65, 63, 60],
  },
  {
    id: 8,
    name: "MakerDAO",
    chains: "1 chain",
    category: "CDP",
    tvl: "$8.12b",
    change1d: "-0.15%",
    values: [90, 88, 85, 82, 81, 81],
  },
  {
    id: 9,
    name: "Uniswap",
    chains: "15 chains",
    category: "DEX",
    tvl: "$5.44b",
    change1d: "+0.88%",
    values: [45, 48, 42, 50, 52, 54],
  },
  {
    id: 10,
    name: "Curve",
    chains: "12 chains",
    category: "DEX",
    tvl: "$2.12b",
    change1d: "-1.20%",
    values: [30, 28, 25, 22, 21, 21],
  },
  {
    id: 11,
    name: "Pendle",
    chains: "6 chains",
    category: "Yield",
    tvl: "$4.15b",
    change1d: "+5.67%",
    values: [10, 15, 22, 35, 38, 41],
  },
  {
    id: 12,
    name: "Rocket Pool",
    chains: "1 chain",
    category: "Liquid Staking",
    tvl: "$3.88b",
    change1d: "+0.33%",
    values: [35, 36, 37, 38, 38, 38],
  },
  {
    id: 13,
    name: "PancakeSwap",
    chains: "9 chains",
    category: "DEX",
    tvl: "$2.10b",
    change1d: "-0.45%",
    values: [25, 24, 23, 22, 21, 21],
  },
  {
    id: 14,
    name: "JustLend",
    chains: "1 chain",
    category: "Lending",
    tvl: "$6.22b",
    change1d: "+0.12%",
    values: [60, 61, 62, 62, 62, 62],
  },
  {
    id: 15,
    name: "Compound V3",
    chains: "5 chains",
    category: "Lending",
    tvl: "$2.45b",
    change1d: "+0.95%",
    values: [20, 21, 22, 23, 24, 24],
  },
  {
    id: 16,
    name: "Arbitrum Bridge",
    chains: "2 chains",
    category: "Bridge",
    tvl: "$3.55b",
    change1d: "+1.05%",
    values: [30, 32, 33, 35, 35, 35],
  },
  {
    id: 17,
    name: "Polygon PoS",
    chains: "1 chain",
    category: "Chain",
    tvl: "$0.92b",
    change1d: "-2.10%",
    values: [15, 14, 12, 11, 10, 9],
  },
  {
    id: 18,
    name: "GMX",
    chains: "2 chains",
    category: "Derivatives",
    tvl: "$0.55b",
    change1d: "+0.77%",
    values: [5, 6, 5, 7, 6, 5],
  },
  {
    id: 19,
    name: "Frax Finance",
    chains: "5 chains",
    category: "Liquid Staking",
    tvl: "$1.12b",
    change1d: "+0.22%",
    values: [10, 11, 11, 11, 12, 11],
  },
  {
    id: 20,
    name: "Morpho Blue",
    chains: "1 chain",
    category: "Lending",
    tvl: "$1.45b",
    change1d: "+4.12%",
    values: [5, 8, 10, 12, 14, 14],
  },
  {
    id: 21,
    name: "Renzo",
    chains: "7 chains",
    category: "Restaking",
    tvl: "$3.12b",
    change1d: "+2.88%",
    values: [15, 18, 22, 28, 30, 31],
  },
  {
    id: 22,
    name: "Kamino",
    chains: "1 chain",
    category: "Lending",
    tvl: "$1.22b",
    change1d: "+1.45%",
    values: [8, 9, 10, 11, 12, 12],
  },
  {
    id: 23,
    name: "Solend",
    chains: "1 chain",
    category: "Lending",
    tvl: "$0.65b",
    change1d: "-0.90%",
    values: [10, 9, 8, 7, 6, 6],
  },
  {
    id: 24,
    name: "Marinade",
    chains: "1 chain",
    category: "Liquid Staking",
    tvl: "$1.88b",
    change1d: "+0.55%",
    values: [15, 16, 17, 18, 18, 18],
  },
  {
    id: 25,
    name: "Puffer Finance",
    chains: "1 chain",
    category: "Restaking",
    tvl: "$1.34b",
    change1d: "+1.90%",
    values: [5, 7, 9, 11, 12, 13],
  },
  {
    id: 26,
    name: "Balancer",
    chains: "8 chains",
    category: "DEX",
    tvl: "$0.98b",
    change1d: "-1.15%",
    values: [12, 11, 10, 10, 10, 9],
  },
  {
    id: 27,
    name: "Sushiswap",
    chains: "18 chains",
    category: "DEX",
    tvl: "$0.45b",
    change1d: "-0.50%",
    values: [8, 7, 7, 6, 5, 4],
  },
  {
    id: 28,
    name: "Blast",
    chains: "1 chain",
    category: "Chain",
    tvl: "$2.10b",
    change1d: "+3.20%",
    values: [10, 12, 15, 18, 20, 21],
  },
  {
    id: 29,
    name: "Base Bridge",
    chains: "2 chains",
    category: "Bridge",
    tvl: "$1.88b",
    change1d: "+2.11%",
    values: [10, 12, 14, 16, 18, 18],
  },
  {
    id: 30,
    name: "Mantle LSP",
    chains: "1 chain",
    category: "Liquid Staking",
    tvl: "$1.25b",
    change1d: "+0.98%",
    values: [8, 9, 10, 11, 12, 12],
  },
];

const StatCard = ({ title, subValue, data, subtitle }) => (
  <div className="bg-[#16191e] border border-gray-800 rounded-lg p-4 flex flex-col h-40 group hover:border-gray-600 transition-colors">
    <div className="flex items-start justify-between mb-2">
      <div>
        <h4 className="flex items-center gap-1 text-white text-md">
          {title} <HelpCircle size={10} className="text-white" />
        </h4>
        <p className="text-sm text-gray-400">{subtitle}</p>
      </div>
    </div>
    <div className="flex-grow mt-2">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data.map((v) => ({ val: v }))}>
          <Bar
            dataKey="val"
            fill="#2469FF"
            radius={[2, 2, 0, 0]}
            barSize={20}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>
);

export default function MainMarket({ setShowModal }) {
  return (
    <div className="bg-[#0f1114] text-[#e5e7eb] min-h-screen font-sans selection:bg-blue-500/30">
      <div className="max-w-[1400px] mx-auto px-6 py-2">
        {/* Top Section Grid */}
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          {/* Left Metrics Column */}
          <p className="text-center bg-[#131516] text-xs lg:hidden p-1 rounded">
            Check out the{" "}
            <span className="underline">2025 State of DeFi Report</span> <br />{" "}
            by DL Research
          </p>
          <div className="space-y-8 lg:col-span-4">
            <button
              className="w-full py-4 bg-[#3e58da] hover:bg-[#273996]
              text-white rounded font-black text-[11px] uppercase tracking-[0.15em] transition-all shadow-lg shadow-blue-500/10 active:scale-[0.98]"
              onClick={() => setShowModal(true)}
            >
              Connect Wallet
            </button>

            <div>
              <h2 className="text-sm  text-[#fff] tracking-[0.2em] mb-1">
                Total Value Locked in DeFi
              </h2>
              <div className="flex items-baseline justify-between gap-3">
                <h1 className="text-xl text-white tabular-nums">$120.607b</h1>
                <p className="text-sm font-bold text-green-400 bg-green-400/10 px-1.5 py-0.5 rounded">
                  +1.62% 24h
                </p>
              </div>
            </div>

            <div className="space-y-6">
              <h3 className="text-sm font-bold tracking-widest text-white ">
                Key Metrics
              </h3>
              <div className="space-y-2">
                {[
                  { label: "Stablecoins Mcap", value: "$308.25b" },
                  { label: "DEXs Volume (24h)", value: "$7.275b" },
                  { label: "Active Users", value: "2.41m" },
                ].map((item) => (
                  <div
                    key={item.label}
                    className="flex items-center justify-between cursor-pointer group"
                  >
                    <span className="text-xs text-gray-400 transition-colors group-hover:text-gray-200">
                      {item.label}
                    </span>
                    <span className="text-xs font-bold text-white tabular-nums">
                      {item.value}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Main Chart Area */}
          <div className="space-y-4 lg:col-span-8">
            <div className="bg-[#16191e] border border-gray-800 rounded-xl p-6 shadow-2xl">
              <div className="flex items-center justify-between mb-8">
                <div className="flex gap-2">
                  <button className="flex items-center gap-2 bg-[#1f232b] border border-gray-700 px-3 py-1.5 rounded text-[10px] font-bold text-gray-400 uppercase tracking-tight hover:border-gray-500">
                    Metrics <Plus size={12} />
                  </button>
                  <div className="flex items-center gap-2 bg-blue-500/10 border border-blue-500/50 text-blue-400 px-3 py-1.5 rounded text-[10px] font-bold uppercase">
                    TVL <X size={12} className="cursor-pointer" />
                  </div>
                </div>
                <button className="p-2 text-gray-500 transition-colors hover:text-white">
                  <Download size={16} />
                </button>
              </div>

              <div className="h-[320px]">
                <ResponsiveContainer width="100%" height="100%">
                  <AreaChart data={chartData}>
                    <defs>
                      <linearGradient id="colorTvl" x1="0" y1="0" x2="0" y2="1">
                        <stop
                          offset="5%"
                          stopColor="#2469FF"
                          stopOpacity={0.2}
                        />
                        <stop
                          offset="95%"
                          stopColor="#2469FF"
                          stopOpacity={0}
                        />
                      </linearGradient>
                    </defs>
                    <CartesianGrid
                      vertical={false}
                      stroke="#1f2937"
                      strokeDasharray="3 3"
                    />
                    <XAxis
                      dataKey="date"
                      axisLine={false}
                      tickLine={false}
                      tick={{ fill: "#6b7280", fontSize: 10 }}
                      dy={10}
                    />
                    <YAxis
                      axisLine={false}
                      tickLine={false}
                      tick={{ fill: "#6b7280", fontSize: 10 }}
                      tickFormatter={(v) => `$${v}b`}
                    />
                    <Tooltip
                      contentStyle={{
                        backgroundColor: "#16191e",
                        border: "1px solid #374151",
                        borderRadius: "8px",
                        fontSize: "12px",
                      }}
                    />
                    <Area
                      type="monotone"
                      dataKey="tvl"
                      stroke="#2469FF"
                      strokeWidth={3}
                      fillOpacity={1}
                      fill="url(#colorTvl)"
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
            </div>

            {/* Performance Cards Grid */}
            <div className="grid grid-cols-1 gap-4 py-4 md:grid-cols-2">
              <StatCard
                title="Upcoming Unlocks"
                subtitle="$181.77m over 14 days"
                data={protocolData[1].values}
              />
              <StatCard
                title="DEXs Volume"
                subtitle="$7.275b (24h)"
                data={protocolData[1].values}
              />
              <StatCard
                title="ETF Inflows"
                subtitle="-$314.6m (24h)"
                data={protocolData[2].values}
              />
              <StatCard
                title="DAT Inflows"
                subtitle="$3.83b (30d)"
                data={protocolData[3].values}
              />
            </div>
          </div>
        </div>

        {/* Assets Table */}
        <div className="bg-[#16191e] border border-gray-800 rounded-xl overflow-hidden shadow-2xl">
          <table className="w-full text-left border-collapse">
            <thead className="bg-[#1a1d23] border-b border-gray-800">
              <tr>
                {["# Name", "Category", "TVL", "1d Change"].map((h, i) => (
                  <th
                    key={h}
                    className={`px-6 py-4 text-[10px] uppercase font-bold text-white tracking-widest ${
                      i > 1 ? "text-right" : ""
                    }`}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {protocolData.map((p) => (
                <tr
                  key={p.id}
                  className="border-b border-gray-800/50 hover:bg-white/[0.02] transition-colors cursor-pointer group"
                >
                  <td className="flex items-center gap-4 px-6 py-5">
                    <span className="w-4 text-xs font-medium text-[#fff]">
                      {p.id}
                    </span>
                    <div>
                      <div className="text-sm font-bold text-blue-400 group-hover:text-blue-300">
                        {p.name}
                      </div>
                      <div className="text-[10px] font-medium text-gray-500 uppercase tracking-tighter">
                        {p.chains}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-5 text-xs font-semibold text-gray-400">
                    {p.category}
                  </td>
                  <td className="px-6 py-5 text-sm font-bold text-right text-white tabular-nums">
                    {p.tvl}
                  </td>
                  <td
                    className={`px-6 py-5 text-right text-xs font-bold tabular-nums ${
                      p.change1d.includes("+")
                        ? "text-green-400"
                        : "text-red-400"
                    }`}
                  >
                    {p.change1d}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
